import styled from 'styled-components'

export const Result = styled.button`
  box-sizing: border-box; display: flex; align-items: center; flex-direction: ${p => p.$visual ? 'column' : 'row'};
  gap: 18px; width: 100%; min-width: 0; text-align: left;
  padding: ${p => p.$visual ? '0 0 16px' : '20px 0'}; background: transparent; border: 0;
  border-bottom: 1px solid ${p => p.theme.palette.colors.borderStrong}; color: ${p => p.theme.palette.colors.text};
  cursor: pointer; font: inherit; transition: background 160ms ease;
  &:focus-visible { outline: 2px solid ${p => p.theme.palette.blue.main}; outline-offset: 4px; border-radius: 6px; }
  &:hover { background: ${p => p.theme.palette.colors.buttonGhost}; }
  &:hover h2 { text-decoration: underline; text-underline-offset: 4px; }
  &:hover > span:last-child { transform: translateX(3px); }
  @media (prefers-reduced-motion: reduce) { &, & * { transition: none !important; } }
  @media (max-width: 600px) { gap: 14px; padding: ${p => p.$visual ? '0 0 16px' : '16px 0'}; }
`
export const Preview = styled.div`
  position: relative; flex-shrink: 0; width: ${p => p.$visual ? '100%' : '144px'};
  aspect-ratio: 4 / 3;
  background: ${p => p.$image ? p.theme.palette.common.white : p.theme.palette.colors.surface};
  color: ${p => p.$image ? p.theme.palette.primary.main : p.theme.palette.colors.text};
  border-radius: 10px; overflow: hidden; display: grid; place-items: center;
  img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: ${p => p.$image ? 'contain' : 'cover'}; }
  > svg { width: 32px; height: 32px; }
  @media (max-width: 600px) { width: ${p => p.$visual ? '100%' : '104px'}; }
`
export const DocumentIcon = styled.div`
  width: 52px; height: 56px; flex-shrink: 0; border-radius: 8px;
  background: ${p => p.theme.palette.colors.surface}; color: ${p => p.theme.palette.colors.text};
  display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 3px;
  svg { width: 26px; height: 26px; }
  span { font-size: 10px; font-weight: 600; letter-spacing: 1px; }
`
export const Details = styled.div`min-width: 0; flex: 1; width: 100%;`
export const Title = styled.h2`
  font-size: 16px; font-weight: 500; line-height: 1.5; margin: 6px 0 0; overflow-wrap: anywhere;
  strong { font-weight: 700; }
`
export const Meta = styled.span`font-size: 12px; line-height: 1.5; color: ${p => p.theme.palette.colors.muted};`
export const Snippet = styled.p`
  font-size: 13px; line-height: 1.6; color: ${p => p.theme.palette.colors.muted}; margin: 8px 0 0; overflow-wrap: anywhere;
  display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
`
export const OpenIndicator = styled.span`
  display: flex; flex-shrink: 0; color: ${p => p.theme.palette.colors.muted}; transition: transform 160ms ease;
  svg { width: 18px; height: 18px; }
  @media (max-width: 600px) { display: none; }
`
export const PlayBadge = styled.span`
  position: absolute; inset: 0; display: grid; place-items: center;
  color: ${p => p.theme.palette.common.white}; background: ${p => p.theme.palette.colors.cardOverlayMiddle};
  svg { width: 36px; height: 36px; }
`
